import { FetchError } from 'ofetch'

export function isAbortError(error: unknown) {
  if (!(error instanceof Error)) return false

  if (typeof error.cause === 'object' && error.cause?.toString().includes('AbortError')) {
    // Wrapped FetchError thrown by ofetch
    return true
  }

  // Native AbortError
  return error.name === 'AbortError'
}

export function isFetchErrorWithStatus(error: unknown, status: number): error is FetchError {
  return error instanceof FetchError && error.response?.status === status
}

export function isAccountSuspendedError(error: unknown): boolean {
  return isFetchErrorWithStatus(error, 423)
}
